
















import Vue from "vue";
import Authenticator from "netlify-auth-providers";
import { MUTATIONS, ACTIONS } from "@/shared/store";

export default Vue.extend({
  data() {
    return {
      loading: false,
    }
  },
  created() {
    this.login();
  },
  methods: {
    requestToken() {
      this.$store.dispatch(ACTIONS.REQUEST_TOKEN)
        .then(() => {
          this.login();
        })
    },
    login() {
      this.$store.commit(MUTATIONS.CLEAR_ERROR);
      this.loading = true;
      this.$store.dispatch(ACTIONS.LOGIN)
        .catch(() => {})
        .then(() => {
          this.loading = false;
        })
    },
  }
});
